import { render, staticRenderFns } from "./KerkenSearch.vue?vue&type=template&id=032285a4&scoped=true"
import script from "./KerkenSearch.vue?vue&type=script&lang=js"
export * from "./KerkenSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032285a4",
  null
  
)

export default component.exports